<template>
  <NuxtLayout name="default" :breadcrumbs="breadcrumbs">
    <NarrowContainer>
      <div
        class="layout-my-account"
        data-testid="account-layout"
      >
        <h1
          v-if="isRoot || isTablet"
          class="mt-4 mb-10 md:my-10 mx-4 md:mx-0 font-bold typography-headline-3 md:typography-headline-2 hidden"
        >
          {{ $t('account.heading') }}
        </h1>
        <div v-else class="flex justify-start items-center mb-4 lg:mb-10 mt-4">
          <div v-for="({ subsections }, i) in sections" :key="i">
            <div v-for="{ label, link } in subsections" :key="label" class="font-bold typography-headline-3">
              <h1 v-if="currentPath === link">{{ label }}</h1>
            </div>
          </div>
        </div>
        <div class="main-my-account" data-testid="account-page-sidebar">
          <div class="sidebar-myAccount">
            <ul class="list-sidebar" v-for="{ title, subsections } in sections" :key="title">
              <li class="text-center" v-for="{ label, link } in subsections" :key="label">
                <SfListItem
                  :tag="NuxtLink"
                  :to="link"
                  :class="[
                      'nav-link',
                      {
                        'active': router.currentRoute.value.path.startsWith(link),
                      },
                    ]"
                >
                  {{ label }}
                </SfListItem>
              </li>
            </ul>
            <NuxtLink to="/" class="logo-sidebar">
              <img src="assets/images/my-account/logo-sidebar.svg" alt="logo"/>
            </NuxtLink>

<!--            <ul class="text-center">-->
<!--              <SfListItem-->
<!--                :tag="NuxtLink"-->
<!--                @click.prevent="logout"-->
<!--                class="!inline-flex logout-my-account gap-2 items-center !w-auto mt-[112px] text-[17px] text-gray-86 text-center uppercase font-450 tracking-[1.87px] hover:!bg-transparent"-->
<!--              >-->
<!--                {{ $t('account.logout') }}-->
<!--                <template>-->
<!--                  <div>-->
<!--                    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="12" viewBox="0 0 9 12" fill="none">-->
<!--                      <path d="M1 1L7 6L1 11" stroke="#8B8A86" stroke-width="2" stroke-linecap="round" />-->
<!--                    </svg>-->
<!--                  </div>-->
<!--                </template>-->
<!--              </SfListItem>-->
<!--            </ul>-->
          </div>
          <div class="content-myAccount">
            <section data-testid="category-grid">
              <slot />
            </section>
          </div>
        </div>
      </div>
    </NarrowContainer>
  </NuxtLayout>
</template>

<script setup lang="ts">
import { SfIconPerson, SfListItem, SfButton, SfIconArrowBack } from '@storefront-ui/vue';

const { isTablet } = useBreakpoints();
const { t } = useI18n();
const router = useRouter();

const sections = [
  {
    title: t('account.accountSettings.heading'),
    icon: SfIconPerson,
    subsections: [
      {
        label: t('account.accountSettings.section.myDashBoard'),
        link: paths.accountMyDashBoard,
      },
      {
        label: t('account.accountSettings.section.myAccount'),
        link: paths.accountMyAccount,
      },
      {
        label: t('account.accountSettings.section.customerQuote'),
        link: paths.accountQuoteData,
      },
      {
        label: t('account.accountSettings.section.myOrder'),
        link: paths.accountMyOrders,
      },
      {
        label: t('account.accountSettings.section.savedCart'),
        link: paths.savedCart,
      },
      {
        label: t('account.accountSettings.section.invoices'),
        link: paths.accountMyInvoices,
      },
      {
        label: t('account.accountSettings.section.warranty'),
        link: paths.warranty,
      },
    ],
  },
];

const currentPath = computed(() => router.currentRoute.value.path);
// eslint-disable-next-line prettier/prettier
const rootPathRegex = new RegExp(`^${paths.account}/?$`);
const isRoot = computed(() => rootPathRegex.test(currentPath.value));
const findCurrentPage = computed(() =>
  sections.flatMap(({ subsections }) => subsections).find(({ link }) => currentPath.value.includes(link)),
);
const breadcrumbs = computed(() => [
  { name: t('home'), link: paths.home },
  { name: t('account.heading'), link: paths.account },
  ...(isRoot.value ? [] : [{ name: findCurrentPage.value?.label, link: currentPath.value }]),
]);

const NuxtLink = resolveComponent('NuxtLink');

const { clear: clearSession } = useUserSession()

async function logout() {
  await clearSession()
  await navigateTo('/')
}

definePageMeta({
  middleware: ['authenticated'],
});
</script>
